import React from "react";
import styles from "./PowerStatus.css";
import cx from "classnames";

interface Props {
  className?: string;
  ignitionOn: boolean;
}

export const PowerStatus = ({ className, ignitionOn }: Props) => {
  if (ignitionOn) {
    return <div className={cx(styles.statusOn, className)}> Ligado</div>;
  }

  return <div className={cx(styles.statusOff, className)}> Desligado </div>;
};
